import { render, staticRenderFns } from "./AccountRemittance.vue?vue&type=template&id=69403291&scoped=true&"
import script from "./AccountRemittance.vue?vue&type=script&lang=js&"
export * from "./AccountRemittance.vue?vue&type=script&lang=js&"
import style0 from "./AccountRemittance.vue?vue&type=style&index=0&id=69403291&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69403291",
  null
  
)

export default component.exports